import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

export const getRotableTransactions = async (params = {}) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/rotable-transactions`, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching rotable transactions:', error.response?.data || error);
    throw error;
  }
};

export const getRotableTransactionById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/rotable-transactions/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching rotable transaction:', error.response?.data || error);
    throw error;
  }
};

export const createRotableTransaction = async (data) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/rotable-transactions`, data);
    return response.data;
  } catch (error) {
    console.error('Error creating rotable transaction:', error.response?.data || error);
    throw error;
  }
};

export const updateRotableTransaction = async (id, data) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/rotable-transactions/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating rotable transaction:', error.response?.data || error);
    throw error;
  }
};

export const deleteRotableTransaction = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/rotable-transactions/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting rotable transaction:', error.response?.data || error);
    throw error;
  }
};
